import React from 'react';
import PropTypes from 'prop-types';

const InsuranceIssuerSelectOption = ({ item, ComboboxOption, ...props }) => (
  <ComboboxOption item={item} {...props}>
    {item.display}{' '}
    {item.state && item.state !== 'US' && <span className="muted">({item.state})</span>}
  </ComboboxOption>
);

InsuranceIssuerSelectOption.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    display: PropTypes.string.isRequired,
    state: PropTypes.string,
  }).isRequired,
};

export default InsuranceIssuerSelectOption;
